'use client';

import { LoginButton } from '@telegram-auth/react';
import { useLocale } from 'next-intl';
import { env } from '~/env';
import { useTelegramLogin } from '../model/mutations';

// Telegram Login Widget supported langs: en, ru, es, it, de, fr, pt
// Georgian (ka) not supported by Telegram — fallback to English.
const tgLangFor = (locale: string): string => {
    if (locale === 'en') return 'en';
    if (locale === 'ka') return 'en';
    return 'ru';
};

export default () => {
    const locale = useLocale();
    const { mutate: onTelegramSubmit } = useTelegramLogin();

    return (
        <LoginButton
            botUsername={env.NEXT_PUBLIC_TELEGRAM_BOT}
            buttonSize='large'
            lang={tgLangFor(locale)}
            onAuthCallback={onTelegramSubmit}
        />
    );
};
